console.log("script loaded");
$(document).ready(function () {

  var installment_provider = $('#payment-provider .payment-item')
  for (let i = 0; i < installment_provider.length; i++) {
    console.log(i)
      $('.payment-item[data-index=' + i + ']').click(function() {
          $('.payment-item').removeClass('payment-selected')
          $('.payment-item[data-index=' + i + ']').addClass('payment-selected')
          var get_payment = $('.installment-label[data-index=' + i + ']').attr('data-payment')
          $('.installment-label').hide()
          $('.installment-label[data-index=' + i + ']').show()
      })
  }

  $('.js-menu__open').click(function () {
    var menu = $(this).attr('data-menu');
    $(menu).toggleClass('js-menu__expanded');
    $(menu).parent().toggleClass('js-menu__expanded');
  });

  $('.js-menu__context, .js-menu__close').click(function (event) {
    if ($(event.target).hasClass('js-menu__context') || $(event.target).hasClass('js-menu__close')) {
      $('.js-menu__expanded').removeClass('js-menu__expanded');
    }
  });

  setTimeout(function () {
    $("#deskSizeChart").accordion({
      collapsible: true,
      heightStyle: "content",
      header: "h4",
      active: false,
    });
    $("#mobileSizeChart").accordion({
      collapsible: true,
      heightStyle: "content",
      header: "h4",
      active: false,
    });

    $("#deskSizeChart h4").addClass("header-accordionna");
    $("#mobileSizeChart h4").addClass("header-accordionna");
  }, 3000);
  
  $(".collection-wrapper").owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    navText: [
      "<div class='nav-btn prev-slide'></div>",
      "<div class='nav-btn next-slide'></div>",
    ],
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: false,
    responsive: {
      0: {
        items: 2,
      },
      640: {
        items: 2,
      },
      1140: {
        items: 4,
      },
    },
  });
  $(".slide-promo-bar").owlCarousel({
    items: 1,
    loop: true,
    nav: false,
    autoHeight: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: false,
  });
  $(".featured-slide-collection").owlCarousel({
    items: 4,
    loop: true,
    nav: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 2
      },
      640: {
        items: 2
      },
      1140: {
        items: 5
      }
    },
    navText: [
      "<div class='nav-btn prev-slide'></div>",
      "<div class='nav-btn next-slide'></div>",
    ],
    autoplay: true,
    autoplayTimeout: 2500,
    autoplayHoverPause: false,
  });

  var acc = document.getElementsByClassName("filter-button");
  var i;
  var url = window.location.pathname;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("filter-active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        if (url.includes('/collections/tada')) {
          panel.style.maxHeight = "100" + "%";
        } else {
          panel.style.maxHeight = "110" + "px";
        }
      }
    });
  }

  $(".filter-toggle").click(function () {
    var $this = $(this);
    var filter_close_toggle = $(".filter-toggle-close");
    if ($this.attr("aria-clicked") == "false") {
      $this.attr("aria-clicked", "true");
      filter_close_toggle.attr("aria-closed", "false");
      $('.collection-sidebar-panel').show()
      $('.scotch-panel-canvas').css('transform', 'unset')
    }
  });
  $(".filter-toggle-close").click(function () {
    var $this = $(this);
    var filter_toggle = $(".filter-toggle");
    if ($this.attr("aria-closed") == "false") {
      $this.attr("aria-closed", "true");
      filter_toggle.attr("aria-clicked", "false");
      $('.collection-sidebar-panel').hide()
      $('.scotch-panel-canvas').css('transform', 'translate3d(0px, 0px, 0px)')
    }
  });

  var min = $('input[name="filter.v.price.gte"]').val();
  if (min == '') {
    min = 0;
  }
  var max = $('input[name="filter.v.price.lte"]').val();
  if (max == '') {
    max = $('input[name="filter.v.price.gte"]').attr('max');
  }

  var fixed_max = $('input[name="filter.v.price.gte"]').attr('max');
  var parts = window.location.href.split('?')[0].split('/');
  var lastSegment = parts.pop() || parts.pop();  // handle potential trailing slash
  if ($('.filter-item.cat').length > 0) {
    if ($('.filter-item.cat').children('.filter-cat').data('value') == lastSegment) {
      $('.filter-item.cat').children('.filter-cat').data('value', lastSegment).prop('checked', true).attr('disabled', true);
    }
  }

  $('.filter-item.cat').click(function () {
    var click_value = $(this).children('.filter-cat').data('value');
    var new_url = lastSegment.replace(lastSegment, click_value);
    if (!$(this).children('.filter-cat').is(':checked')) {
      window.location.href = new_url;
    }
  });

  $('.filter-cat').change(function () {
    if (this.checked) {
      var click_value = $(this).data('value');
      var new_url = lastSegment.replace(lastSegment, click_value);
      window.location.href = new_url;
    }
  });

  $('#flat-slider').slider({
    orientation: 'horizontal',
    range: true,
    animate: true,
    min: 0,
    max: Number(fixed_max),
    values: [Number(min), Number(max)],
    slide: function (event, ui) {
      if ((ui.values[1] - ui.values[0]) < 1) {
        return false;
      }

      $('input[name="filter.v.price.gte"]').val(ui.values[0])
      $('input[name="filter.v.price.lte"]').val(ui.values[1])
      window.location.href = window.location.href.split('?')[0] + '?filter.v.price.gte=' + ui.values[0] + '&filter.v.price.lte=' + ui.values[1]

    }
  });

  url = window.location.href;
  is_product = url.match(/.*\/products\/.*/);
  // console.log(url, is_product);
  if (window.location.href.includes('collections')) {
    if (is_product == null) {
      // document.querySelector('#SortBy').addEventListener('change', function () {
      //   const urlSearchParams = new URLSearchParams(window.location.search);
      //   urlSearchParams.set(this.name, this.value);
      //   window.location = `?${urlSearchParams}`;
      // });
      // $('.size-digit-kebawah').appendTo('.2digit_kebawah');
      // $('.size-digit-keatas[data-sort-type=UK]').appendTo('.type-uk');
      // $('.size-digit-keatas[data-sort-type=US]').appendTo('.type-us');
      // $('.size-digit-keatas[data-sort-type=EUR]').appendTo('.type-eur');
      // function sortEm(a,b){
      //   return parseInt($(a).attr('data-sort-nomor')) > parseInt($(b).attr('data-sort-nomor')) ? 1 : -1;
      // }
      // $('.type-uk li').sort(sortEm).prependTo($('.type-uk'));
      // $('.type-us li').sort(sortEm).prependTo($('.type-us'));
      // $('.type-eur li').sort(sortEm).prependTo($('.type-eur'));
      var announce_height = $('#shopify-section-promo-bar').outerHeight();
      var header_height = $('.site-header-container').outerHeight();
      var headerc_height = $('.collection-header').outerHeight();
      // console.log(announce_height);
      // console.log(header_height);
      // console.log(headerc_height);
      var hasil_gabungan = announce_height + headerc_height;
      var window_height = $(window).height();
      var hasil_final = window_height - header_height;
      var hasil_mobile_lebih = header_height + headerc_height;
      var hasil_mobile_kurang = announce_height + header_height + headerc_height;
      $('.filter-sticky .panel').css('top', hasil_mobile_kurang + 'px');
      $(window).scroll(function () {
        if ($(this).scrollTop() > hasil_gabungan) {
          $('.filter-sticky').addClass('is-sticky')
          $('.filter-sticky.is-sticky').css('max-height', 800 + 'px');
          $('.filter-sticky.is-sticky').css('top', 120 + 'px');
          $('.scotch-panel-wrapper').css('overflow', 'unset');
        } else {
          $('.filter-sticky').removeClass('is-sticky')
          $('.filter-sticky').css('max-height', 'inherit');
          $('.scotch-panel-wrapper').css('overflow', 'hidden');
        }
        if ($(this).scrollTop() > announce_height) {
          $('.filter-sticky .panel').css('top', hasil_mobile_lebih + 'px');
        } else {
          $('.filter-sticky .panel').css('top', hasil_mobile_kurang + 'px');
        }
      })
    }
  }

  function getCartItems() {
    jQuery.getJSON('/cart.js', function (cart) {
      if (cart.item_count > 0) {
        console.log(cart.items)
      } else {
        console.log('There no items in the cart.');
      }
    });
  }

  setTimeout(() => {
    getCartItems();
  }, 400);

  function getCart() {
      jQuery.getJSON('/cart.js', function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: cart
        }));

        let cartData = cart.items;
        if (cart.item_count > 0) {
          refreshCart(cart, cartData)
          console.log(cartData)
          jQuery('#cart-nav > div > .cart-header > p').remove();

          var buttonAtc = `
          	<div class="row expanded">
              <div class="small-12 columns">
                <a href="/checkout" id="checkout-button" class="button">Checkout</a>
              </div>
          	</div>
          `;
          // var redeem_voucher = `
          // 	<div class="row expanded redeem-voucher">
          //     <div class="small-12 columns">
          //       <span>Redeem Your Rewards <a href="/account?view=member">Here</a></span>
          //     </div>
          // 	</div>
          // `;
          if (jQuery('.cart-action-buttons #checkout-button').length < 1) {
            jQuery(buttonAtc).appendTo('.cart-action-buttons');
          }
        }
        else {
          jQuery('<p>You have no items in cart</p>').appendTo('#cart-nav > div > .cart-header');
          jQuery('#cart-nav > div > .cart-body > table').remove();
          jQuery('#cart-nav > div > .cart-body > table').remove();
          jQuery('.cart-action-buttons #checkout-button').remove();
        }

        jQuery('#checkout-button').click(function () {
          var hrefna = jQuery(this).attr('href')
          if (window.location.host == '127.0.0.1:9292') {
            alert(window.location.host + hrefna)
          } else {
            window.location.href = 'https://' + window.location.host + '/' + hrefna;
          }
        })
      });
    }

    function refreshCart(cart, cartData) {
      var tampungItem = '';

      $.each(cartData, function (index, value) {
        console.log(value)
        var pricena = "" + value.final_line_price + "";
        var pricenaFormat = pricena.substring(0, pricena.length - 2);
        // console.log(pricenaFormat)
        // console.log(parseInt(pricenaFormat))

        tampungItem += `
            <tr>
              <td class="line-item-image cart-image">
                <img src="${value.image}">	
              </td>
              <td class="line-item-title">
                ${value.title}
                <div class="line-item-operations">
                  <button type="button" data-variant-id="${value.variant_id}" data-quantity="${value.quantity}" class="button change-item">+</button>
                  <button type="button" data-variant-id="${value.variant_id}" data-quantity="${value.quantity}" class="button change-item">-</button>
                  <button type="button" data-variant-id="${value.variant_id}" data-quantity="${value.quantity}" class="button change-item">x</button>
                </div>
              </td>
              <td class="line-item-quantity">x${value.quantity}</td>
              <td class="line-item-price">Rp. ${number_format(parseInt(pricenaFormat))}</td>
            </tr>
        	`;
      })

      var totalPricena = "" + cart.items_subtotal_price + "";
      var totalPricenaFormat = totalPricena.substring(0, totalPricena.length - 2);
      var bodyCart = `
      <table>
        <tbody>
        ${tampungItem}
        </tbody>
        <tbody>
          <tr>
            <td colspan="2">Subtotal</td>
            <td></td>
            <td class="line-item-price">Rp. ${number_format(parseInt(totalPricenaFormat))}</td>
          </tr>
        </tbody>
      </table>
      <div id="append-sekarang"></div>
      `;

      if ($('#cart-nav').length > 0) {
        jQuery('#cart-nav > div > .cart-body').html(bodyCart);
      }
      else {
        jQuery(bodyCart).prependTo('#cart-nav > div > .cart-body');
      }

      // console.log($('.js-menu__context').length);

      jQuery('.change-item').click(function () {
        var idnaItem = jQuery(this).attr('data-variant-id');
        var qty = parseInt(jQuery(this).attr('data-quantity'));

        console.log(idnaItem, qty)

        var url = '/cart/change.js';
        if (jQuery(this).text() == '+') {
          qty = 1;
          url = '/cart/add.js';
          console.log(qty)
        }
        else if (jQuery(this).text() == '-') {
          qty = qty - 1;
        }
        else if (jQuery(this).text() == 'x') {
          qty = 0;
        }

        $.ajax({
          type: "POST",
          url: url,
          dataType: "json",
          data: {
            id: parseFloat(idnaItem),
            quantity: qty,
          },
        }).then((data) => {
          getCart();
        }).catch((error) => {
          // console.error('Error add to cart', error.responseJSON.description);
          alert(error.responseJSON.description);
        });
      })
    }

  if (is_product) {
    function number_formats(amount) {
      // Create our number formatter.
      var formatter = new Intl.NumberFormat('id-ID', {
        maximumFractionDigits: 0
      });

      return formatter.format(amount); /* $2,500.00 */
    }

    $("#AddToCartForm").submit(function (x) {
      x.preventDefault();
      const idna = $('[name=id]').val();
      const qtyna = $('#productQuantity').val();

      console.log(idna, qtyna)
      var items = [{ quantity: qtyna, id: idna }];

      $.ajax({
        type: "POST",
        url: '/cart/add.json',
        data: {
          items: items
        },
        success: function (data) {
          console.log('success');
        },
        errors: function (err) {
          console.log(err);
        },
        dataType: 'application/json'
      });
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: qtyna,
          id: idna
        },
      }).then((data) => {
        console.log('Success:', data);
        setTimeout(function () {
          if (jQuery('.js-menu__context.js-menu__expanded').length < 1) {
            jQuery('#cart-nav').toggleClass('js-menu__expanded')
            jQuery('#cart-nav').parent().toggleClass('js-menu__expanded')
          }
        }, 1000);
        setTimeout(() => {
          jQuery('.js-menu__close').trigger('click');
        }, 5000);
        setTimeout(function () {
          getCart();
        }, 400);
      }).catch((error) => {
        console.error('Error add to cart', error.responseJSON.description);
        alert(error.responseJSON.description);
      });
      // Now I will do a get to show the itens from cart

    })

  }

  jQuery('.change-item').click(function () {
    var idnaItem = jQuery(this).attr('data-variant-id');
    var qty = parseInt(jQuery(this).attr('data-quantity'));

    console.log(idnaItem, qty)

    var url = '/cart/change.js';
    if (jQuery(this).text() == '+') {
      qty = 1;
      url = '/cart/add.js';
      console.log(qty)
    }
    else if (jQuery(this).text() == '-') {
      qty = qty - 1;
    }
    else if (jQuery(this).text() == 'x') {
      qty = 0;
    }

    $.ajax({
      type: "POST",
      url: url,
      dataType: "json",
      data: {
        id: parseFloat(idnaItem),
        quantity: qty,
      },
    }).then((data) => {
      console.log(data)
      getCart();
    }).catch((error) => {
      // console.error('Error add to cart', error.responseJSON.description);
      alert(error.responseJSON.description);
    });
  })

  jQuery('#checkout-button').click(function () {
    var hrefna = jQuery(this).attr('href')
    if (window.location.host == '127.0.0.1:9292') {
      window.location.href = window.location.host + '/' + hrefna;
    } else {
      window.location.href = 'https://' + window.location.host + '/' + hrefna;
    }
  })

  var url = window.location.href;
  var segment = url.split("/").length - 1 - (url.indexOf("https://") == -1 ? 0 : 2);
  var segment_tags = url.split("+").length
  var segment_tags_test = url.split("+")
  console.log(segment_tags_test);
  console.log(segment_tags, segment);

  jQuery('#filter-resets').click(function () {
    var data_url = jQuery(this).attr('data-url');
    if (segment == 5) {
      location.href = data_url;
    } else if (segment_tags > 1) {
      location.href = data_url;
    } else if (segment_tags == 1 && segment == 4) {
      return false;
    }
  })

});
